import { css, Global } from '@emotion/react';
import normalize from 'emotion-normalize';
import SpoqaHanSansNeoLight from "../font/SpoqaHanSansNeo-Light.otf"
import SpoqaHanSansNeoThin from "../font/SpoqaHanSansNeo-Thin.otf"
import SpoqaHanSansNeoRegular from "../font/SpoqaHanSansNeo-Regular.otf"
import SpoqaHanSansNeoMedium from "../font/SpoqaHanSansNeo-Medium.otf"
import SpoqaHanSansNeoBold from "../font/SpoqaHanSansNeo-Bold.otf"
const globalStyles = css`
  ${normalize};

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    src: url(${SpoqaHanSansNeoLight}) format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    src: url(${SpoqaHanSansNeoThin}) format('opentype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    src: url(${SpoqaHanSansNeoRegular}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    src: url(${SpoqaHanSansNeoMedium}) format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Spoqa Han Sans Neo';
    src: url(${SpoqaHanSansNeoBold}) format('opentype');
    font-weight: 700;
    font-style: normal;
  }

  * {
    font-family: 'Spoqa Han Sans Neo', 'Pretendard', sans-serif;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

const GlobalStyles = () => <Global styles={globalStyles} />;

export default GlobalStyles;
